<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Podtytuł',
              modelPath: [this, 'form', 'subtitle'],
              multilingual: true
            })
          ]
        }
      ]
    }
  }
}
</script>
